import axios from 'axios';
import ElasticSearch from './ElasticSearch';

const index_region_pages = 'region_pages';

export default class RegionPagesES extends ElasticSearch {
    static get indexRegios() {
        return this.applyIndexPrefix(index_region_pages);
    }

    static getRegionPages()
    {
        const index = RegionPagesES.indexRegios;
        const data = {
            from: 0,
            size: 100
        };

        return axios.post(`/${this.endpoint}/${index}/_search`, data);
    }

    static getRegionPage(slug) {
        const index = RegionPagesES.indexRegios;
        const data = {
            query: {
                bool: {
                    must: [
                        { match: { "region.slug": slug } }
                    ]
                }
            }
        };

        return axios.post(`/${this.endpoint}/${index}/_search`, data);
    }
}
